import request from '@/utils/request'

export function fetchRecordsList(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/tenth-anniversary/blessing/records',
    method: 'get',
    params: {
      topN: 24,
    }
  })
}

export function fetchBlessing() {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/tenth-anniversary/blessing',
    method: 'post',
    // params: data
  })
}





// WEBPACK FOOTER //
// ./src/views/activity_210/api.js